import { queryClient } from "api/client"
import { AppWrapper } from "components/AppWrapper/AppWrapper"
import { NewReleaseNotification } from "components/NewReleaseNotification/NewReleaseNotification"
import { Notification } from "components/Notification/Notification"
import { Outlet } from "react-router"

/**
 * The layout for the root router.
 */
export const RootLayout = () => (
  <AppWrapper queryClient={queryClient}>
    <Outlet />
    <Notification />
    <NewReleaseNotification />
  </AppWrapper>
)
